import React from 'react';
import { Modal, CircularProgress, Grid, Box } from '@mui/material';
import { keyframes } from '@mui/system';

import { BadgePropsType } from './Type';

/* Animations */
const fadeScale = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.95);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const pulseRing = keyframes`
  0% {
    transform: scale(0.9);
    opacity: 0.8;
  }
  70% {
    opacity: 0.35;
  }
  100% {
    transform: scale(2.2);
    opacity: 0;
  }
`;

export function Loader(props: BadgePropsType): JSX.Element {
  const { children, overly, loading } = props;

  return (
    <>
      <Modal
        open={loading}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backdropFilter: 'blur(6px)',
          backgroundColor: 'rgba(0, 0, 0, 0.35)',
        }}
      >
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{
            height: '100%',
            animation: `${fadeScale} 0.25s ease-out`,
          }}
        >
          <Box
            sx={{
              position: 'relative',
              width: 90,
              height: 90,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.08)',
              boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
            }}
          >
            {/* Pulsing Ring */}
            <Box
              sx={{
                position: 'absolute',
                inset: '-40%', // makes pulse much bigger
                borderRadius: '50%',
                border: '3px solid',
                borderColor: 'primary.main',
                animation: `${pulseRing} 1.8s ease-out infinite`,
                boxShadow: '0 0 20px rgba(234, 238, 241, 0.45)',
              }}
            />

            {/* Main Loader */}
            <CircularProgress size={36} thickness={4} color="primary" />
          </Box>
        </Grid>
      </Modal>

      {overly && children}
    </>
  );
}

export default Loader;
